module.exports = __webpack_public_path__ + "static/img/10002 (3).f7f8d05.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10002 (3).webp
// module id = Sy1d
// module chunks = 14